/**
 * MeetingTypeService
 * Service for MeetingType entity operations
 * Route: api/meetingtypes
 * Controller: MeetingTypesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingTypeService
 * Handles meeting type CRUD operations
 * Maps to /api/meetingtypes endpoint
 */
export class MeetingTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingTypeService.DEFAULT_SERVICE_PATH,
            basePath: MeetingTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingTypeService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingTypeService.BASE_PATH = 'api/meetingtypes';
//# sourceMappingURL=MeetingTypeService.js.map